import { Box } from "@mui/material";

import { Button } from "./Button";

interface FloatingNavigationButtonProps {
  label: string;
  href: string;
  replace?: boolean;
  onClick?: () => void;
}

export function FloatingNavigationButton(props: FloatingNavigationButtonProps) {
  const { label, href, replace, onClick } = props;

  return (
    <Box
      sx={{
        position: "absolute",
        bottom: (theme) => theme.spacing(8),
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 1,
      }}
    >
      <Button variant="contained" size="medium" href={href} replace={replace} onClick={onClick}>
        {label}
      </Button>
    </Box>
  );
}
